import { StoryFn, Meta } from "@storybook/react";

import SearchTags, { CategoryType } from "./SearchTags";

const exampleData = [
  {
    id: 1,
    name: "Food & Drink",
    type: CategoryType.NORMAL,
  },
  {
    id: 2,
    name: "Coffee",
    type: CategoryType.NORMAL,
  },
  {
    id: 3,
    name: "Toilets",
    type: CategoryType.NORMAL,
  },
  {
    id: 4,
    name: "Shops",
    type: CategoryType.NORMAL,
  },
  {
    id: 5,
    name: "Lounges",
    type: CategoryType.NORMAL,
  },
  {
    id: 6,
    name: "ATMs",
    type: CategoryType.NORMAL,
  },
  {
    id: 7,
    name: "Drinking Water",
    type: CategoryType.NORMAL,
  },
  {
    id: 8,
    name: "Device Charging",
    type: CategoryType.NORMAL,
  },
  {
    id: 9,
    name: "Food & Drink 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 10,
    name: "Coffee 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 11,
    name: "Toilets 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 12,
    name: "Shops 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 13,
    name: "Lounges 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 14,
    name: "ATMs 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 15,
    name: "Drinking Water 2",
    type: CategoryType.NORMAL,
  },
  {
    id: 16,
    name: "Device Charging 2",
    type: CategoryType.NORMAL,
  },
];

export default {
  title: "SearchTags",
  component: SearchTags,
  argTypes: {},
} as Meta<typeof SearchTags>;

const Template1: StoryFn<typeof SearchTags> = (args) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 2rem)",
      }}
    >
      <div style={{ width: "75%" }}>
        <SearchTags {...args} />
      </div>
    </div>
  );
};

export const Desktop = Template1.bind({});
Desktop.args = {
  dataQA: "search-tags",
  data: exampleData,
  enableArrows: true,
  initialOffset: 0,
  itemGap: 8,
  onClick: (seletion) => console.log("You selected: ", seletion),
};

const Template2: StoryFn<typeof SearchTags> = (args) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 2rem)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40%",
          maxWidth: "375px",
          height: "75%",
          border: "2px solid black",
          borderRadius: "24px",
        }}
      >
        <SearchTags {...args} />
      </div>
    </div>
  );
};

export const Mobile = Template2.bind({});
Mobile.args = {
  dataQA: "search-tags",
  data: exampleData,
  enableArrows: false,
  initialOffset: 16,
  itemGap: 8,
  onClick: (seletion) => console.log("You selected: ", seletion),
};
